import * as z from "zod";

export const createRequestSchema = z.object({
  name: z.string().min(1, "Request name is required."),
  content: z.string().min(1, "Request content is required."),
  category_id: z.string().optional(),
  groups: z.array(z.string()),
  chain_with: z.array(z.object({ requestId: z.string() })),
});

export type CreateRequestFormValues = z.infer<typeof createRequestSchema>;

export const createCategorySchema = z.object({
  name: z.string().min(1, "Category name is required."),
  description: z.string().min(1, "Description is required."),
  groups: z.array(z.string()),
});

export type CategoryFormValues = z.infer<typeof createCategorySchema>;
